import { Component, OnInit, ViewChild,Inject,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-subject',
  templateUrl: './subject.component.html',
  styleUrls: ['./subject.component.css'],
  providers: [HelperService] 
})

export class SubjectComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
  @ViewChild(DataTableDirective)
  @ViewChild("fileInput") fileInput;
  @ViewChild("fileInput2") fileInput2;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas;
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  all:any=[];
  selected:any=[];
  grade_id=0;
  subject_name='';
  subject_icon='';
  subject_id='';
  syllabus_id;
  syllabusname;
  gradename;
  gradeid;
  user_permissions:any=[];
  subjetbtndisbled = false;
  subjeteditbtndisbled= false;
  user=this.cookie.get('user_id');
  teacherroles;
  user_roleid;checkIfTeacher;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router, public dialog: MatDialog,private cookie:CookieService) {
    this.activatedRouter.params.subscribe((params: Params) => {
      this.grade_id = params['grade'];
      this.syllabus_id = params['syllabus_id'];
      this.gradeid = params['gradeid'];
      //alert(this.syllabus_id);
    });

    
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })
    
    .subscribe(data => {
      let body = JSON.parse(data['_body']);
      // this.datas = JSON.parse(data['_body']).users[0];
      // this.user_roleid = JSON.parse(data['_body']).users[0]['role_id'];
      // //console.log(this.datas);
      // this.teacherroles = JSON.parse(data['_body']).teacherroles;
      // console.log(this.teacherroles);
      // console.log(this.user_roleid);
      //console.log(this.teacherroles.includes(this.user_roleid));
      //this.checkIfTeacher = this.teacherroles.includes(this.user_roleid);
      this.checkIfTeacher = body.success;
      if(this.checkIfTeacher == false)
      {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/subject/'+this.grade_id,{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
      
        this.datas = data;
          this.dtTrigger.next();
               
      });
    }
    else
    {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
      
      this.http.get(this.helper.base_url+'http/get/subject/'+this.grade_id+'?teacher_id=1',{ headers: this.headers })
        .map(this.extractData)
        .subscribe(data => {
        
          this.datas = data;
            this.dtTrigger.next();
                 
        });
      }
    });
      this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
    this.http.get(this.helper.base_url+'http/get/gradedetails/'+this.gradeid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.gradename = body.data[0].name;
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  }
  

  
  addClick(e){
    this.http.get(this.helper.base_url+'http/get/subjects/'+this.grade_id,{ headers: this.headers })
      .subscribe(
         
          (data) => {
            this.selected=JSON.parse(data.text())['data']['temp'];
            this.all=JSON.parse(data.text())['data']['subjects'];
            //console.log(this.selected);
            // this.refresh();
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      );
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  deleteClick(id){
  
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
      }).onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/subject_grade/'+id,{ headers: this.headers })
        .subscribe(
           
            (data) => {
              let body = JSON.parse(data['_body']);
              //console.log(body)
               if(body.success == 1)
               {
                this.listClick(null) ;
                this.refresh(false,body.message) ;
               }
               else
               {
                this.snackbar.open(body.message, null, {
                  duration:5000,
                    extraClasses:'error-snackbar',
                    verticalPosition:'top'
                  });
               }
            },
              //this.refresh(false,'Subject deleted from grade'), //For Success Response
            err => {console.error(err)} //For Error Response
        );   
      });
  }
   subjectonchage(status,id){
   if(status){
    this.selected.push(id);
   }else{
     let index = this.selected.indexOf(id);
 
    if (index > -1) {
       this.selected.splice(index, 1);
    }
   }
 
 }


 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["subject/"+this.grade_id,this.syllabus_id,this.gradeid]));
      
 }
 add_form(addForm: NgForm){
   this.subjetbtndisbled = true;
  let body = new FormData();

  //body.append('subjects[]', this.selected);
 

  if(addForm.value.name){
    body.append('subjects', addForm.value.name);
    let fi = this.fileInput.nativeElement;
    body.append('file', fi.files[0]);
   this.http.post(this.helper.base_url+'http/add/subject_grade/'+this.grade_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      let body = JSON.parse(res['_body']);
      this.subjetbtndisbled = false;
      //console.log(body)
       if(body.success == 1)
       {
       
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
  //     this.listClick(null) ;
  //  this.refresh(false,'Subject added to grade') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
    }
    else
    {
      this.snackbar.open("Provide a value", null, {
        duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
    }
 }
 editClick(id,name,icon){
  this.list=false;
  this.edit=true;
  this.add=false;
  this.icon=this.helper.list_icon;
  this.icon_action="listClick";
  this.subject_name=name;
  this.subject_icon=this.helper.aws_url+icon;
  this.subject_id=id;
}
update_form(updateForm: NgForm){
  this.subjeteditbtndisbled = true;
  let id =this.subject_id;
  let body = new FormData();
  let fi = this.fileInput2.nativeElement;
  body.append('name', updateForm.value.name);
  body.append('file', fi.files[0]);
  body.append('syllabusgradeid', updateForm.value.grade_id);
 
  this.http.post(this.helper.base_url+'http/update/subject_grade/'+id, body,{ headers: this.headers })
  .subscribe(
    (res) => {
      let body = JSON.parse(res['_body']);
      this.subjeteditbtndisbled = false;
      //console.log(body)
       if(body.success == 1)
       {
         
        this.listClick(null) ;
        this.refresh(false,body.message) ;
       }
       else
       {
        this.snackbar.open(body.message, null, {
          duration:5000,
            extraClasses:'error-snackbar',
            verticalPosition:'top'
          });
       }
    //  this.listClick(null) ;
    //  this.refresh(false,'Subject updated successfully') ;
    }, //For Success Response
     err => {console.error(err)} //For Error Response);
  );
}
 encryt(subid,gradeid,addForm: NgForm){
  this.snackbar.open('Success', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
}

publishClick(id){
  
   
  // this.snackbar.open('Are you sure!', 'Delete', {
  //   duration: 10000,
  //   extraClasses:  ['warning-snackbar'],
  // }).onAction().subscribe(() => {
    this.http.get(this.helper.base_url+'http/publish/subject_grade/'+id+'/'+this.grade_id,{ headers: this.headers })
    .subscribe(
       
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body)
           if(body.success == 1)
           {
            this.listClick(null) ;
            this.refresh(false,body.message) ;
           }
           else
           {
            this.snackbar.open(body.message, null, {
              duration:5000,
                extraClasses:'error-snackbar',
                verticalPosition:'top'
              });
           }
        },
          //this.refresh(false,'Subject deleted from grade'), //For Success Response
        err => {console.error(err)} //For Error Response
    );   
  //});
}
 


  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

  backbtn(){
   window.history.back();
 }


  openDialog(subid,gradeid) {
    document.location.href = this.helper.base_url+'http/vedio/encrypt/subject/'+gradeid+'/'+subid+'?user_id=0';
  }
    openDialog2(subid,gradeid,price) {
    const dialogRef2 = this.dialog.open(PriceDialogBox, {
      height: '330px',
      width:'40%',

      data: { subid: subid,gradeid: gradeid,price:price },
    });

    dialogRef2.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }
}



@Component({
  selector: 'user-dialog-box',
  templateUrl: "user-dialog-box.html",
})
export class UserDialogBox {
  users:any=[];
  foods:any=[];
  subid='';
  gradeid='';
  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;

  search_text='';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private http:Http) {
    this.subid=data.subid;
    this.gradeid=data.gradeid;
    
    this.http.get('http://app.appzoc.com/anns2/backend/http/get/students',)
    .subscribe(
       
        (data) => {
                 this.users=JSON.parse(data['_body']);
                 //console.log(this.foods);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
 
  }
  user_dialog(userDialog: NgForm){
  
    let user=userDialog.value.user;
    document.location.href = 'http://app.appzoc.com/anns2/backend/http/vedio/encrypt/subject/'+this.gradeid+'/'+this.subid+'?user_id='+user;
  

  }
  ngOnInit() {
       this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
   }

   private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.users.filter(option => option.toLowerCase().includes(filterValue));
  }
  user_search(event){
   if(event!=''){
       this.http.get('http://app.appzoc.com/anns2/backend/http/search/students?word='+event,)
    .subscribe(
       
        (data) => {
                 this.users=JSON.parse(data['_body']);
               
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
   }
  }
}
@Component({
  selector: 'price-dialog-box',
  templateUrl: "price-dialog-box.html",
})
export class PriceDialogBox {
  users:any=[];
  foods:any=[];
 subid='';
  gradeid='';
  price='';
  dialog=MAT_DIALOG_DATA;
  constructor(public dialogRef2: MatDialogRef<SubjectComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private http:Http,private snackbar: MatSnackBar,private router:Router) {
    this.price=data.price;
    this.subid=data.subid;
    this.gradeid=data.gradeid;
   
  
  }
  price_dialog(userDialog: NgForm){
  
    let user=userDialog.value.price;
    this.http.get('http://app.appzoc.com/anns2/backend/http/update/subject_price?price='+this.price+'&subid='+this.subid+'&gradeid='+this
      .gradeid,)
    .subscribe(
       
        (data) => {
               this.dialogRef2.close();
        
           this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
  

  }
  refresh(val=false,msg=''){
   
  this.snackbar.open('Price updated', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["subject/"+this.gradeid]));
      
 }
  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/subject/subject.component.ts